import type { Reward } from '../../../components/loyalty/data/types';

export const FETCH_AUTOMATED_REWARDS_REQUEST = 'loyalty/automatedRewards/FETCH_AUTOMATED_REWARDS_REQUEST';
export const FETCH_AUTOMATED_REWARDS_SUCCESS = 'loyalty/automatedRewards/FETCH_AUTOMATED_REWARDS_SUCCESS';
export const FETCH_AUTOMATED_REWARDS_FAILURE = 'loyalty/automatedRewards/FETCH_AUTOMATED_REWARDS_FAILURE';

export const CLEAR_AUTOMATED_REWARDS_ERROR = 'loyalty/automatedRewards/CLEAR_AUTOMATED_REWARDS_ERROR';

export interface LoyaltyAutomatedRewardsState {
  automatedRewards: Reward[];
  loading: boolean;
  error: string | null;
  configLoaded: boolean;
}
